module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('amounts-component', {
    attrs: {
      "subsidiary-id": _vm.params.idSubsidiary
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "single-line": ""
    },
    model: {
      value: (_vm.params.idSubsidiary),
      callback: function($$v) {
        _vm.params.idSubsidiary = $$v
      },
      expression: "params.idSubsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "mb-3": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select mr3",
    attrs: {
      "hide-details": "",
      "placeholder": "Top",
      "items": _vm.top,
      "single-line": ""
    },
    model: {
      value: (_vm.topValue),
      callback: function($$v) {
        _vm.topValue = $$v
      },
      expression: "topValue"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select mr3",
    attrs: {
      "hide-details": "",
      "placeholder": "Reservas",
      "items": _vm.bookings,
      "single-line": ""
    },
    model: {
      value: (_vm.booking),
      callback: function($$v) {
        _vm.booking = $$v
      },
      expression: "booking"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Nueva Empresa",
      "href": _vm.createHref
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-options": "",
      "include-settings": "",
      "include-delete-single": ""
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-delete-event": _vm.deleteRow,
      "on-delete-selected": _vm.deleteRows,
      "on-export-selected": _vm.exportRows,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.rzSocial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingsNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.totalExpenses), props.row.currency)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.accounts), props.row.currency)))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6287f6f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/companies/companies-list.vue
// module id = 1649
// module chunks = 59